export default {
  props:['data'],
  render(){
    const { data } = this
    const extra = []
    if( data.installType == 1){
      extra.push( <sl-detail-list-item title="IMEI">{data.standardCarImei}</sl-detail-list-item> )
      extra.push( <sl-detail-list-item title="车辆编号">{data.standardCarNo}</sl-detail-list-item> )
    }else if( data.installType == 3 ){
      extra.push( <sl-detail-list-item title="车牌号">{data.standardCarLicense}</sl-detail-list-item> )
    }
    return (
      <sl-detail-list col={1} label-width="75px" label-align="right" style="padding:12px;">
        { extra }
        <sl-detail-list-item title="照片">
          {
            data.reformImages ? <sl-carousel images={data.reformImages.split(';')} /> : null
          }
        </sl-detail-list-item>
        <sl-detail-list-item title="备注">{data.reformRemark}</sl-detail-list-item>
      </sl-detail-list>
    )
  }
}